import { IReceivingSectorContext } from "Interfaces/Providers/receivingSector";
import { ReceivingSectorContext } from "providers/Settings/ReceivingSector";
import { useContext } from "react";

export default function useReceivingSector(): IReceivingSectorContext {
  const context = useContext(ReceivingSectorContext);

  return context;
}
